import React from 'react';
import {
  FormattedDate,
  FormattedTime,
  FormattedRelative,
} from 'react-intl';
import PropTypes from 'prop-types';

export default function Time({ value, showRelative, splitLine }) {
  const date = new Date(value);
  const today = new Date();

  return (
    <span>
      {
        today.toDateString() === date.toDateString() ?
          <span>
            at <FormattedTime value={date} />
          </span>
          :
          <span>
            on <FormattedDate value={date} />
            &nbsp;at <FormattedTime value={date} />
          </span>
      } {
        showRelative && splitLine &&
          <div>(<FormattedRelative value={date} />)</div>
      } {
        showRelative && !splitLine &&
          <span>(<FormattedRelative value={date} />)</span>
      }

    </span>
  );
}

Time.propTypes = {
  value: PropTypes.string.isRequired,
  showRelative: PropTypes.bool.isRequired,
  splitLine: PropTypes.bool.isRequired,
};

Time.defaultProps = {
  showRelative: true,
  splitLine: false,
};



// WEBPACK FOOTER //
// ./app/components/Time.jsx